import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './notificationWrapper.css';

export class NotificationComponent extends Component {
    render() {
        // The ToastContainer only needs to be rendered once in your app,
        // but keeping it here preserves the wrapper pattern.
        return (
            <div className="notificationStyle">
                <ToastContainer />
            </div>
        );
    }

    /**
     * used to show notifications
     * @param type = "success" | "error" | "info" | "warn"
     * @param msg
     */
    _addNotification(type, msg) {
        // Map levels to react-toastify functions
        switch(type) {
            case "success":
                toast.success(msg, { style: { backgroundColor: "green", color: "#fff" }});
                break;
            case "error":
                toast.error(msg, { style: { backgroundColor: "rgb(228, 190, 190)", color: "#222" }});
                break;
            case "info":
                toast.info(msg);
                break;
            case "warning":
            case "warn":
                toast.warning(msg);
                break;
            default:
                toast(msg);
                break;
        }
    }
}
